// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screen-container{position:fixed;width:100%;height:100%;top:0;z-index:99;background:rgba(0,0,0,.8901960784)}.mobile-menu{width:100%;text-align:center;background:#fafafa;height:100%;display:block;z-index:100;top:0;position:fixed;opacity:.95;padding-top:25px}.mobile-link{font-size:25px;color:#000;display:block;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
